<script>
    import { onMount } from "svelte";

    import { apiMethods } from "../../../Services/index.svelte";

    import { showError } from "../../../Utils/utilFunctions.svelte";

    export let updatePhase = () => {};
    export let personalDetails = {};

    const __RESEND__COOLDOWN = 60000;
    const __CHECKVERIFICATION__COLLDOWN = 2000;

    let isResendingCount = false,
        resendCoolDown = __RESEND__COOLDOWN;

    onMount(async () => {
        if (personalDetails.email) checkEmailVerification();
    });

    const sendVerificationEmail = async (isResend = false) => {
        await apiMethods.postMethod.sendVerificationEmail();

        if (isResend) _updateCountDown();
    };

    const checkEmailVerification = () => {
        const checkProcess = () => {
            apiMethods.getMethod
                .getUserById(personalDetails.createdUserId)
                .then((res) => {
                    // res.verifiedEmail = true;

                    if (res.id == personalDetails.createdUserId) {
                        if (res.verifiedEmail) updatePhase(3);
                        else
                            setTimeout(
                                checkProcess,
                                __CHECKVERIFICATION__COLLDOWN,
                            );
                    } else if (res.error) showError(res.error);
                });
        };

        setTimeout(() => {
            checkProcess();
        }, __CHECKVERIFICATION__COLLDOWN);
    };

    const redirectToPrivacyPolicy = () => {
        window.open("https://www.anaemate.com.au/privacy", "_blank");
    };

    const goBackPhase = () => {
        updatePhase(1);
    };

    const resendEmail = () => {
        isResendingCount = true;

        sendVerificationEmail(true);
    };

    // HELPER FUNCTIONS
    const _updateCountDown = () => {
        const countDown = () => {
            resendCoolDown -= 1000;

            if (resendCoolDown < 0) {
                clearInterval(timer);
                isResendingCount = false;
                resendCoolDown = __RESEND__COOLDOWN;
            }
        };

        const timer = setInterval(countDown, 1000);
    };
</script>

<p class="text-[32px] font-bold text-primary">Email Validation</p>

<p class="text-[16px] text-gray-600">
    You're almost there! We sent an email to
    <span class="font-bold">{personalDetails.email}</span>
</p>

<p class="text-[16px] text-gray-600">
    Just click on the link in that email to complete your signup. If you don't
    see it, you may need to click your spam folder.
</p>

<div class="flex w-full justify-between items-center">
    <p class="text-[16px] text-gray-600">Can't find the email?</p>
    <button
        class="btn btn-secondary btn-sm"
        on:click|preventDefault={resendEmail}
        disabled={isResendingCount}
    >
        Resend {isResendingCount
            ? `(${Math.floor(resendCoolDown / 1000)})`
            : ""}
    </button>
</div>

<div class="flex flex-col gap-y-2">
    <p class="text-[16px] text-gray-600">COLLECTION OF YOUR PERSONAL DETAILS</p>

    <p class="text-[14px] text-gray-600">
        TCI Health Pty Ltd is an Australian private company offering secure
        cloud-based billing services. TCI Health manages personal information in
        accordance with the Australian Privacy Principles. We store your
        personal information on Amazon Web Services using industry-standard best
        practices, including encryption.
    </p>

    <p class="text-[14px] text-gray-600">
        When you sign up as a user we collect your personal information
        including your name, date of birth, and AHPRA number, which are required
        to register you with health funds and third party payers, and your
        banking details in order to pay you. We will disclose your information
        via email or post when we register your provider number(s) with heath
        funds and third party payers, as per their instructions.
    </p>

    <p class="text-[14px] text-gray-600">
        Our full privacy policy will be displayed at the end of the onboarding
        form, or you can view it at any time by going to
        <span
            class="text-secondary underline cursor-pointer"
            on:click|preventDefault={redirectToPrivacyPolicy}
        >
            https://www.anaemate.com.au/privacy
        </span>
    </p>
</div>

<button class="btn btn-sm btn-secondary" on:click|preventDefault={goBackPhase}>
    Back
</button>
